import {Alert} from "@commons/components/bootstrap/alert";
import {Busy} from "@commons/layout/busy";
import type {LoginPage} from "@login/loginPage";
import type {LoginRequest} from "hol-dto";
import type {HolLoginResponse} from "hol-dto";

export class LoginState
{
    static instance: LoginState;
    
    readonly alert: Alert;
    readonly busy: Busy;
    
    /**
     * Reference to login page
     */
    loginPage: LoginPage;
    
    model: any|undefined;

    /**
     * Data from previous steps when multistep login is required
     * @type {LoginRequest}
     */
    loginPayload: LoginRequest|undefined;

    constructor(loginPage: LoginPage) 
    {
        this.loginPage = loginPage;
        this.alert = new Alert();
        this.busy = Busy.instance;
    }
    
    onForgotPasswordClick(): void
    {
        this.loginPage.onForgotPasswordClick();
    }
    
    onReturnToSignIn()
    {
        this.loginPage.onReturnToSignIn();
    }
    
    onLogin(loginResponse: HolLoginResponse): void
    {
        this.loginPage.onLogin(loginResponse);
    }

    onLocation(loginResponse: HolLoginResponse): void
    {
        this.loginPage.onLocation(loginResponse);
    }
    
    registerListeners()
    {
        window.addEventListener("unhandledrejection", event => 
        {
            event.preventDefault();
            this.alert.show(event.reason)}
        );
    }
}
